import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-remove-refund-method',
    templateUrl: './remove-refund-method.component.html',
    styleUrls: ['./remove-refund-method.component.scss'],
    imports: [RouterOutlet]
})
export class RemoveRefundMethodComponent { }
